import { compose, converge, not, prop, and } from 'ramda';

import { COUPON_QUERY } from 'app/router/constants/paths';
import { getDecodedParsedSearch } from 'app/router/selectors';

const parsedCoupon = compose(prop(COUPON_QUERY), getDecodedParsedSearch);

const coupon = prop('coupon');

const selectedCoupon = compose(prop('code'), coupon);

const couponFlowPath = compose(prop('flowPath'), coupon);

const isCouponValid = compose(prop('isValid'), coupon);

const isLoading = compose(prop('isLoading'), coupon);

const isSelectedCouponInValid = converge(and, [
  selectedCoupon,
  compose(not, isCouponValid),
]);

export {
  coupon,
  parsedCoupon,
  isCouponValid,
  selectedCoupon,
  isLoading,
  isSelectedCouponInValid,
  couponFlowPath,
};
